import React from 'react'
import { useSelector } from 'react-redux'

import { SiteState } from '../store/site-reducer'
import Layout from '../components/layout'
import Intro from '../components/intro'
import SelectModuleCard from '../components/select-module-card'
import Row, { Slot } from '../components/row'
import copy from '../static-copy/selectmodule.json'
import Button from '../components/button'
import styles from '../component-styles/selectmodule.module.scss'
import SiteWrapper from '../components/sitewrapper'
import colors from '../theme/colors'
import ConnectAnalyticsBlocker from '../components/connect-analytics-blocker'

export default function SelectModule(): React.ReactElement {
  const { details } = useSelector((s: any): any => s.user)

  const { selected } = useSelector(({ site }: { site: SiteState }) => site)

  const name = details?.firstName ? `, ${details.firstName}.` : ''

  if (
    selected &&
    (selected.preSetup ||
      (selected.blankAccount && selected.dataSource !== 'AA_REPORT') ||
      selected.billingState === 'preSetup')
  ) {
    const billingNotSet = selected.billingState === 'preSetup'
    return (
      <SiteWrapper>
        <Layout>
          <Intro />
          <ConnectAnalyticsBlocker billingNotSet={billingNotSet} />
        </Layout>
      </SiteWrapper>
    )
  }

  return (
    <SiteWrapper>
      <Layout>
        <Intro title={`Welcome back${name}`}>
          <Row>
            <Slot>
              <p className={styles.info}>
                Select a module below to get started:
              </p>
            </Slot>
            <Slot width={300}>
              <Button
                style={{ fontSize: '1.4rem' }}
                href="https://trello.com/b/s9BFtNje/uplifter-public-trello"
                newTab
              >
                Click here for our latest roadmap
              </Button>
            </Slot>
          </Row>
        </Intro>
        <Row>
          {selected?.trackAvailable ? (
            <Slot width={550} className={styles.moduleBox}>
              <SelectModuleCard {...copy.cards.track} color={colors.track} />
            </Slot>
          ) : null}

          {selected?.auditAvailable ? (
            <Slot width={550} className={styles.moduleBox}>
              <SelectModuleCard {...copy.cards.audit} color={colors.audit} />
            </Slot>
          ) : null}

          {selected?.reportAvailable ? (
            <Slot width={550} className={styles.moduleBox}>
              <SelectModuleCard {...copy.cards.report} color={colors.report} />
            </Slot>
          ) : null}

          {selected?.explainAvailable ? (
            <Slot width={550} className={styles.moduleBox}>
              <SelectModuleCard
                {...copy.cards.explain}
                color={colors.explain}
              />
            </Slot>
          ) : null}
        </Row>
      </Layout>
    </SiteWrapper>
  )
}
